// extracted by mini-css-extract-plugin
export var notificationHost = "_lo-0";